<template>
	<div>
		<!-- 列表 -->
		<Popup
			v-model="list_display"
			title="查看"
			confirmBtnText="新增"
			@confirmClick="handleAddClick"
		>
			<div v-loading="list_loading" style="padding: 15px;">
				<!-- 表格 -->
				<div class="base_table">
					<el-table
						:data="list_data"
						style="width: 100%"
					>
						<el-table-column
							prop="formatTime"
							label="时间"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							width="300"
						>
							<template slot-scope="scope">
								<el-button
									@click="handleViewClick(scope.row)"
								>查看</el-button>
								<el-button
									type="danger"
									@click="handleDeleteClick(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 表格 end -->
				
				<!-- 页码 -->
				<div class="clear_both" style="margin-top: 20px;">
					<div class="base_pager" style="float: right;">
						<el-pagination 
							layout="total, prev, pager, next, jumper" 
							next-text="下一页" 
							:total="list_total"
							:current-page="list_page"
							@current-change="handleListPageChange"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 页码 end-->
			</div>
		</Popup>
		<!-- 列表 end-->
		
		<!-- 新增 end-->
		<Popup
			v-model="add_display"
			title="新增"
			@confirmClick="handleAddConfirmClick"
		>
			<div v-loading="add_loading" style="padding: 15px;">
				<!-- 基本信息 -->
				<div class="base_form_row" style="padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">一、基本信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;"><span style="color: #f00;">*</span>训练时间</span>
					<el-date-picker
						v-model="add_date"
						:editable="false"
						placeholder="训练时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleAddDateChange"
					>
					</el-date-picker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="add_dateTip"><i class="b_icon"></i>请选择训练时间</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">患者姓名</span>
					<el-input :value="userInfo.u_r_name" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">所属机构</span>
					<el-input :value="firmName" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;"><span style="color: #f00;">*</span>带训人</span>
					<el-autocomplete
						v-model="add_trainerModel"
						value-key="eglTrainerName"
						:fetch-suggestions="queryTrainer"
						placeholder="带训人"
						style="width: 200px;"
						@select="handleAddTrainerSelect"
					></el-autocomplete>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="add_trainerTip"><i class="b_icon"></i>请选择带训人</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">第二带训人</span>
					<el-autocomplete
						v-model="add_trainerSubModel"
						value-key="eglTrainerName"
						:fetch-suggestions="queryTrainer"
						placeholder="第二带训人"
						style="width: 200px;"
						@select="handleAddSubTrainerSelect"
					></el-autocomplete>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="add_trainerSubTip"><i class="b_icon"></i>请选择第二带训人</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练类型</span>
					<el-input :value="add_type" class="b_inp" disabled></el-input>
				</div>
				<!-- 基本信息 end -->
				
				<!-- 软件训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">二、软件训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练项目</span>
					<el-input :value="add_softwareProject" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input :value="add_softwareContent" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<div>
						<span v-for="v in software_training_situation" :key="v.id" class="b_chip" :class="{'b_chip_active': add_softwareRecord_chips.indexOf(v.id) != -1}" @click="handleAddSoftwareRecordChipClick(v.id)">{{ v.example }}</span>
					</div>
					<div style="margin-top: 10px;">
						<el-input v-model="add_softwareRecord" :rows="4" class="b_inp" type="textarea" placeholder="患者训练配合度、认真度、沟通解决方式"></el-input>
					</div>
				</div>
				<!-- 软件训练 end -->
				
				<!-- 小器械训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">三、小器械训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">小器械项目</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="add_materialProject">
							<el-checkbox v-for="v in materials" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input v-model="add_materialContent" :rows="4" class="b_inp" type="textarea" placeholder="①翻转拍：±2.00D，40cm，20/30“E”字卡，Rx2 Lx2 OUx2   ②裂隙尺：单孔训练，卡片8困难，圆圈无法看出立体感。"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<div>
						<span v-for="v in material_training_situation" :key="v.id" class="b_chip" :class="{'b_chip_active': add_materialRecord_chips.indexOf(v.id) != -1}" @click="handleAddMaterialRecordChipClick(v.id)">{{ v.example }}</span>
					</div>
					<div style="margin-top: 10px;">
						<el-input v-model="add_materialRecord" :rows="4" class="b_inp" type="textarea" placeholder="患者训练配合度、认真度、沟通解决方式"></el-input>
					</div>
				</div>
				<div v-for="(v, i) in add_uploadImgSrc" :key="i" class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<div  class="base_upload">
						<el-image
							class="b_show_img"
							:src="v"
						>
						</el-image>
						<i class="b_delete" @click="handleAddImgDeleteClick(i)"></i>
					</div>
				</div>
				<div v-if="add_uploadImgSrc.length < 3" class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">上传图片（限3张）</span>
					<div class="base_upload" @click="handleAddUploadClick">
						<div class="b_control">
							<img src="../../../../../assets/images/upload_icon.png" alt="">
						</div>
					</div>
				</div>
				<!-- 小器械训练 end -->
				
				<!-- 备注 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">四、备注信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">备注</span>
					<el-input v-model="add_remark" class="b_inp" maxlength="100" show-word-limit placeholder="了解新的信息，以及对训练的建议和意见"></el-input>
				</div>
				<!-- 备注 end -->
			</div>
		</Popup>
		<!-- 新增 end-->
		
		<!-- 查看 end-->
		<Popup
			v-model="view_display"
			title="查看"
			confirmBtnText="修改"
			@confirmClick="handleUpdateClick"
		>
			<div v-loading="view_loading" style="padding: 15px;">
				<!-- 基本信息 -->
				<div class="base_form_row" style="padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">一、基本信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练时间</span>
					<el-input :value="view_info.formatTime" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">患者姓名</span>
					<el-input :value="userInfo.u_r_name" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">所属机构</span>
					<el-input :value="firmName" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">带训人</span>
					<el-input :value="view_info.guideDoctorName" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">第二带训人</span>
					<el-input :value="view_info.guideSecondDoctorName" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练类型</span>
					<el-input :value="view_info.trainingType" class="b_inp" disabled></el-input>
				</div>
				<!-- 基本信息 end -->
				
				<!-- 软件训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">二、软件训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练项目</span>
					<el-input :value="view_info.trainingProject" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input :value="view_info.trainingContent" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<el-input :value="view_info.trainingEffect" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<!-- 软件训练 end -->
				
				<!-- 小器械训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">三、小器械训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">小器械项目</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="view_materialProject" disabled>
							<el-checkbox v-for="v in materials" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input :value="view_info.smallInstrumentsContent" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<el-input :value="view_info.smallInstrumentsEffect" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<div v-for="(v, i) in view_uploadImgSrc" :key="i" class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<div class="base_upload" @click="handleViewUploadImgClick(v)">
						<el-image
							class="b_show_img"
							:src="v"
						>
						</el-image>
					</div>
				</div>
				<!-- 小器械训练 end -->
				
				<!-- 备注 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">四、备注信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">备注</span>
					<el-input :value="view_info.umemo || ''" class="b_inp" disabled></el-input>
				</div>
				<!-- 备注 end -->
			</div>
		</Popup>
		<!-- 查看 end-->
		
		<!-- 修改 end-->
		<Popup
			v-model="update_display"
			title="修改"
			@confirmClick="handleUpdateConfirmClick"
		>
			<div v-loading="update_loading" style="padding: 15px;">
				<!-- 基本信息 -->
				<div class="base_form_row" style="padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">一、基本信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;"><span style="color: #f00;">*</span>训练时间</span>
					<el-date-picker
						v-model="update_date"
						:editable="false"
						placeholder="训练时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleUpdateDateChange"
					>
					</el-date-picker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="update_dateTip"><i class="b_icon"></i>请选择训练时间</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">患者姓名</span>
					<el-input :value="userInfo.u_r_name" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">所属机构</span>
					<el-input :value="firmName" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">带训人</span>
					<el-autocomplete
						v-model="update_trainerModel"
						value-key="eglTrainerName"
						:fetch-suggestions="queryTrainer"
						placeholder="带训人"
						style="width: 200px;"
						@select="handleUpdateTrainerSelect"
					></el-autocomplete>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="update_trainerTip"><i class="b_icon"></i>请选择带训人</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">第二带训人</span>
					<el-autocomplete
						v-model="update_trainerSubModel"
						value-key="eglTrainerName"
						:fetch-suggestions="queryTrainer"
						placeholder="第二带训人"
						style="width: 200px;"
						@select="handleUpdateSubTrainerSelect"
					></el-autocomplete>
				</div>
				<div class="base_tip" style="padding: 0 0 0 150px;"><template v-if="update_trainerSubTip"><i class="b_icon"></i>请选择第二带训人</template></div>
				<div class="base_form_row" style="padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练类型</span>
					<el-input :value="update_type" class="b_inp" disabled></el-input>
				</div>
				<!-- 基本信息 end -->
				
				<!-- 软件训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">二、软件训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练项目</span>
					<el-input :value="update_softwareProject" class="b_inp" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input :value="update_softwareContent" :rows="4" class="b_inp" type="textarea" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<div>
						<span v-for="v in software_training_situation" :key="v.id" class="b_chip" :class="{'b_chip_active': update_softwareRecord_chips.indexOf(v.id) != -1}" @click="handleUpdateSoftwareRecordChipClick(v.id)">{{ v.example }}</span>
					</div>
					<div style="margin-top: 10px;">
						<el-input v-model="update_softwareRecord" :rows="4" class="b_inp" type="textarea" placeholder="患者训练配合度、认真度、沟通解决方式"></el-input>
					</div>
				</div>
				<!-- 软件训练 end -->
				
				<!-- 小器械训练 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">三、小器械训练</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">小器械项目</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="update_materialProject" @change="handleUpdateMaterialProjectChange">
							<el-checkbox v-for="v in materials" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">具体内容</span>
					<el-input v-model="update_materialContent" :rows="4" class="b_inp" type="textarea" placeholder="①翻转拍：±2.00D，40cm，20/30“E”字卡，Rx2 Lx2 OUx2   ②裂隙尺：单孔训练，卡片8困难，圆圈无法看出立体感。"></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">训练情况</span>
					<div>
						<span v-for="v in material_training_situation" :key="v.id" class="b_chip" :class="{'b_chip_active': update_materialRecord_chips.indexOf(v.id) != -1}" @click="handleUpdateMaterialRecordChipClick(v.id)">{{ v.example }}</span>
					</div>
					<div style="margin-top: 10px;">
						<el-input v-model="update_materialRecord" :rows="4" class="b_inp" type="textarea" placeholder="患者训练配合度、认真度、沟通解决方式"></el-input>
					</div>
				</div>
				<div v-for="(v, i) in update_uploadImgSrc" :key="i" class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<div class="base_upload">
						<el-image
							class="b_show_img"
							:src="v"
						>
						</el-image>
						<i class="b_delete" @click="handleUpdateImgDeleteClick(i)"></i>
					</div>
				</div>
				<div v-if="update_uploadImgSrc.length < 3" class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">上传图片（限3张）</span>
					<div class="base_upload" @click="handleUpdateUploadClick">
						<div class="b_control">
							<img src="../../../../../assets/images/upload_icon.png" alt="">
						</div>
					</div>
				</div>
				<!-- 小器械训练 end -->
				
				<!-- 备注 -->
				<div class="base_form_row" style="margin-top: 50px;padding: 0 0 0 150px;border-bottom: 1px dashed #ccc;">
					<span class="b_label" style="width: 140px;">四、备注信息</span>
				</div>
				<div class="base_form_row" style="margin-top: 20px;padding: 0 0 0 150px;">
					<span class="b_label" style="width: 140px;">备注</span>
					<el-input v-model="update_remark" class="b_inp" maxlength="100" show-word-limit placeholder="了解新的信息，以及对训练的建议和意见"></el-input>
				</div>
				<!-- 备注 end -->
			</div>
		</Popup>
		<!-- 修改 end-->
		
		<!-- 图片裁剪 -->
		<div v-if="imgCutterDisplay" style="position: absolute;z-index: 99;width: 100%;height: 100%;top: 0;left: 0;">
			<ImgCutter
				:cutWidth="474"
				:cutHeight="267"
				:sizeChange="false"
				:moveAble="false"
				ref="imgCutterModal"
				@cutDown="imgCutterCutDown"
				@onClearAll="imgCutterClear"
			>
				<span slot="open"></span>
			</ImgCutter>
		</div>
		<!-- 图片裁剪 end -->
		
		<!-- 图片预览 -->
		<transition name="fade_transition">
			<div v-if="viewerDisplay" style="position: absolute;z-index: 99;width: 100%;height: 100%;top: 0;left: 0;">
				<el-image-viewer
					:on-close="closeViewer" 
					:url-list="viewerImgList" 
				/>
			</div>
		</transition>
		<!-- 图片预览 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import BaseMethods from '../../../../../assets/js/base.js';
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				required: true
			},
			code: {
				type: String,
				required: true
			},
			firmId: {
				type: String,
				required: true
			},
			firmName: {
				type: String,
				required: true
			}
		},
		mounted () {
			this.add_trainerId = '';
			this.add_trainerName = '';
			this.add_trainerSubId = '';
			this.add_trainerSubName = '';
			this.update_trainerId = '';
			this.update_trainerName = '';
			this.update_trainerSubId = '';
			this.update_trainerSubName = '';
			this.update_oldMaterialProject = [];
			this.imgCutterType = '';
			this.display && (this.list_display = true);
		},
		data() {
			return {
				userInfo: {},
				materials: [],
				viewerDisplay: false,
				viewerImgList: [],
				software_training_situation: [],
				material_training_situation: [],
				
				list_display: false,
				list_loading: false,
				list_data: [],
				list_total: 0,
				list_page: 1,
				
				add_display: false,
				add_loading: false,
				add_date: '',
				add_trainerModel: '',
				add_trainerSubModel: '',
				add_type: '训练室训练',
				add_softwareProject: '',
				add_softwareContent: '',
				add_softwareRecord_chips: [],
				add_softwareRecord: '',
				add_materialProject: [],
				add_materialContent: '',
				add_materialRecord_chips: [],
				add_materialRecord: '',
				add_remark: '',
				add_dateTip: false,
				add_trainerTip: false,
				add_trainerSubTip: false,
				add_uploadImgSrc: [],
				
				view_display: false,
				view_loading: false,
				view_info: {},
				view_materialProject: [],
				view_uploadImgSrc: [],
				
				update_display: false,
				update_loading: false,
				update_date: '',
				update_trainerModel: '',
				update_trainerSubModel: '',
				update_type: '训练室训练',
				update_softwareProject: '',
				update_softwareContent: '',
				update_softwareRecord_chips: [],
				update_softwareRecord: '',
				update_materialProject: [],
				update_materialContent: '',
				update_materialRecord_chips: [],
				update_materialRecord: '',
				update_remark: '',
				update_dateTip: false,
				update_trainerTip: false,
				update_trainerSubTip: false,
				update_uploadImgSrc: [],
				
				imgCutterDisplay: false
			}
		},
		methods: {
			/****************** @list **********************/
			// 获取用户信息
			getUserInfo() {
				const that = this;
				that.list_loading = true;
				var requestData = {
					uCode: that.code,
					type: 'w'
				};
				Api.findUserInfo(requestData).then((res) => {
					if (res.data.success) {
						that.userInfo = res.data.data;
						that.getMaterials();
					} else {
						that.list_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取小器械
			getMaterials() {
				const that = this;
				Api.getMaterials().then((res) => {
					if (res.data.success) {
						res.data.data && res.data.data.forEach(v => {
							that.materials.push({
								id: v.titleNameId,
								name: v.titleName,
								example: v.example
							});
						});
						that.getSoftwareTrainingSituation();
					} else {
						that.list_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取软件训练情况
			getSoftwareTrainingSituation() {
				const that = this;
				Api.getWithTrainingSituation({type: 1}).then((res) => {
					if (res.data.success) {
						that.software_training_situation = res.data.data || [];
						that.getMaterialTrainingSituation();
					} else {
						that.list_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取小器械训练情况
			getMaterialTrainingSituation() {
				const that = this;
				Api.getWithTrainingSituation({type: 2}).then((res) => {
					if (res.data.success) {
						that.material_training_situation = res.data.data || [];
						that.getList();
					} else {
						that.list_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取列表数据
			getList() {
				const that = this;
				that.list_loading = true;
				var requestData = {
					id: that.uid,
					limit: 10,
					pageNum: that.list_page
				};
				Api.findWithTraining(requestData).then((res) => {
					that.list_loading = false;
					if (res.data.success) {
						that.list_total = res.data.data.totalItems;
						that.list_data = [];
						res.data.data.data.forEach((v) => {
							v.formatTime = v.createTime ? v.createTime.split(' ')[0] : '';
							that.list_data.push(v);
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 切换页码
			handleListPageChange(page) {
				if (this.medicalList_page != page) {
					this.list_page = page;
					this.getList();
				}
			},
			
			/****************** @add **********************/
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 选择训练时间
			handleAddDateChange() {
				if (this.add_date) {
					var destTime = new Date(this.add_date).getTime(),
						nowTime = new Date().getTime();
					if (destTime > nowTime) {
						this.$message.warning('训练时间不能超过当天');
						this.add_date = '';
					} else {
						this.getWithTrainingInfoByDate('add');
					}
				} else {
					this.add_softwareProject = '';
					this.add_softwareContent = '';
				}
			},
			// 带训人选择
			handleAddTrainerSelect(data) {
				this.add_trainerId = data.id;
				this.add_trainerName = data.eglTrainerName;
			},
			// 第二带训人选择
			handleAddSubTrainerSelect(data) {
				this.add_trainerSubId = data.id;
				this.add_trainerSubName = data.eglTrainerName;
			},
			// 软件训练情况选择
			handleAddSoftwareRecordChipClick(id) {
				let index = this.add_softwareRecord_chips.indexOf(id);
				index == -1
				? this.add_softwareRecord_chips.push(id)
				: this.add_softwareRecord_chips.splice(index, 1);
			},
			// 小器械训练情况选择
			handleAddMaterialRecordChipClick(id) {
				let index = this.add_materialRecord_chips.indexOf(id);
				index == -1
				? this.add_materialRecord_chips.push(id)
				: this.add_materialRecord_chips.splice(index, 1);
			},
			// 点击上传图片
			handleAddUploadClick() {
				this.imgCutterType = 'add';
				this.imgCutterDisplay = true;
				this.$nextTick(() => {
					this.$refs.imgCutterModal.handleOpen();
				});
			},
			// 删除上传图片
			handleAddImgDeleteClick(index) {
				this.add_uploadImgSrc.splice(index, 1);
			},
			// 点击新增弹出框确定按钮
			handleAddConfirmClick() {
				const that = this;
				if (!that.add_date) {
					that.add_dateTip = true;
					return false;
				} else {
					that.add_dateTip = false;
				}
				if (!that.add_trainerId) {
					that.add_trainerTip = true;
					return false;
				} else {
					that.add_trainerTip = false;
				}
				if (that.add_trainerSubModel) {
					if (!that.add_trainerSubId) {
						that.add_trainerSubTip = true;
						return false;
					} else {
						that.add_trainerSubTip = false;
					}
				}
				let software_effect = that.add_softwareRecord;
				let material_effect = that.add_materialRecord;
				that.software_training_situation.forEach(v1 => {
					that.add_softwareRecord_chips.forEach(v2 => {
						v1.id == v2 && (software_effect += v1.example);
					});
				});
				that.material_training_situation.forEach(v1 => {
					that.add_materialRecord_chips.forEach(v2 => {
						v1.id == v2 && (material_effect += v1.example);
					});
				});
				that.add_loading = true;
				var requestData = {
					"checkFeedback": null,
					"createTime": that.add_date,
					"createrId": that.add_trainerId,
					"dr": null,
					"guideDoctorId": that.add_trainerId,
					"guideDoctorName": that.add_trainerName,
					"guideSecondDoctorId": that.add_trainerSubId,
					"guideSecondDoctorName": that.add_trainerSubName,
					"id": null,
					"smallInstruments": that.add_materialProject.join(','),
					"smallInstrumentsContent": that.add_materialContent,
					"smallInstrumentsEffect": material_effect,
					"smallInstrumentsPicurl": that.add_uploadImgSrc.join(','),
					"trainingContent": that.add_softwareContent,
					"trainingEffect": software_effect,
					"trainingProject": that.add_softwareProject,
					"trainingType": that.add_type,
					"uenterpriseId": that.userInfo.uenterpriseId,
					"uenterpriseName": that.firmName,
					"umemo": that.add_remark,
					"updateTime": null,
					"userId": that.userInfo.uid,
					"userName": that.userInfo.u_r_name
				};
				Api.newWithTraining(requestData).then((res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.add_display = false;
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/****************** @view **********************/
			// 点击查看
			handleViewClick(data) {
				this.view_info = data;
				this.view_materialProject = this.view_info.smallInstruments ? this.view_info.smallInstruments.split(',') : [];
				this.view_uploadImgSrc = this.view_info.smallInstrumentsPicurl ? this.view_info.smallInstrumentsPicurl.split(',') : [];
				this.view_display = true;
			},
			// 预览图片
			handleViewUploadImgClick(src) {
				this.viewerImgList = [src];
				this.viewerDisplay = true;
			},
			
			/****************** @update **********************/
			// 点击修改
			handleUpdateClick() {
				this.update_date = this.view_info.formatTime;
				this.update_trainerId = this.view_info.guideDoctorId;
				this.update_trainerName = this.view_info.guideDoctorName;
				this.update_trainerSubId = this.view_info.guideSecondDoctorId;
				this.update_trainerSubName = this.view_info.guideSecondDoctorName;
				this.update_trainerModel = this.view_info.guideDoctorName;
				this.update_trainerSubModel = this.view_info.guideSecondDoctorName;
				this.update_softwareProject = this.view_info.trainingProject;
				this.update_softwareContent = this.view_info.trainingContent;
				this.update_softwareRecord = this.view_info.trainingEffect;
				this.update_materialProject = this.view_info.smallInstruments ? this.view_info.smallInstruments.split(',') : [];
				this.update_oldMaterialProject = this.update_materialProject;
				this.update_materialContent = this.view_info.smallInstrumentsContent;
				this.update_materialRecord = this.view_info.smallInstrumentsEffect;
				this.update_remark = this.view_info.umemo || '';
				this.update_uploadImgSrc = this.view_uploadImgSrc;
				this.view_display = false;
				this.update_display = true;
			},
			// 选择训练时间
			handleUpdateDateChange() {
				if (this.update_date) {
					var destTime = new Date(this.update_date).getTime(),
						nowTime = new Date().getTime();
					if (destTime > nowTime) {
						this.$message.warning('训练时间不能超过当天');
						this.update_date = '';
					} else {
						this.getWithTrainingInfoByDate('update');
					}
				} else {
					this.update_softwareProject = '';
					this.update_softwareContent = '';
				}
			},
			// 带训人选择
			handleUpdateTrainerSelect(data) {
				this.update_trainerId = data.id;
				this.update_trainerName = data.eglTrainerName;
			},
			// 第二带训人选择
			handleUpdateSubTrainerSelect(data) {
				this.update_trainerSubId = data.id;
				this.update_trainerSubName = data.eglTrainerName;
			},
			// 软件训练情况选择
			handleUpdateSoftwareRecordChipClick(id) {
				let index = this.update_softwareRecord_chips.indexOf(id);
				index == -1
				? this.update_softwareRecord_chips.push(id)
				: this.update_softwareRecord_chips.splice(index, 1);
			},
			// 小器械训练项目选择
			handleUpdateMaterialProjectChange() {
				if (this.update_materialProject.length > this.update_oldMaterialProject.length) {
					let id = BaseMethods.getDiffFromDoubleArr(this.update_materialProject, this.update_oldMaterialProject)[0];
					let content = '';
					this.materials.forEach(v => {
						id == v.id && (content = v.example);
					});
					this.update_materialContent += content;					
				}
				this.update_oldMaterialProject = this.update_materialProject;
			},
			// 小器械训练情况选择
			handleUpdateMaterialRecordChipClick(id) {
				let index = this.update_materialRecord_chips.indexOf(id);
				index == -1
				? this.update_materialRecord_chips.push(id)
				: this.update_materialRecord_chips.splice(index, 1);
			},
			// 点击上传图片
			handleUpdateUploadClick() {
				this.imgCutterType = 'update';
				this.imgCutterDisplay = true;
				this.$nextTick(() => {
					this.$refs.imgCutterModal.handleOpen();
				});
			},
			// 删除上传图片
			handleUpdateImgDeleteClick(index) {
				this.update_uploadImgSrc.splice(index, 1);
			},
			// 点击修改弹出框确定按钮
			handleUpdateConfirmClick() {
				const that = this;
				if (!that.update_date) {
					that.update_dateTip = true;
					return false;
				} else {
					that.update_dateTip = false;
				}
				if (!that.update_trainerId) {
					that.update_trainerTip = true;
					return false;
				} else {
					that.update_trainerTip = false;
				}
				if (that.update_trainerSubModel) {
					if (!that.update_trainerSubId) {
						that.update_trainerSubTip = true;
						return false;
					} else {
						that.update_trainerSubTip = false;
					}
				}
				let software_effect = that.update_softwareRecord;
				let material_effect = that.update_materialRecord;
				that.software_training_situation.forEach(v1 => {
					that.update_softwareRecord_chips.forEach(v2 => {
						v1.id == v2 && (software_effect += v1.example);
					});
				});
				that.material_training_situation.forEach(v1 => {
					that.update_materialRecord_chips.forEach(v2 => {
						v1.id == v2 && (material_effect += v1.example);
					});
				});
				that.update_loading = true;
				var requestData = {
					"checkFeedback": null,
					"createTime": null,
					"createrId": that.update_trainerId,
					"dr": null,
					"guideDoctorId": that.update_trainerId,
					"guideDoctorName": that.update_trainerName,
					"guideSecondDoctorId": that.update_trainerSubId,
					"guideSecondDoctorName": that.update_trainerSubName,
					"id": that.view_info.id,
					"smallInstruments": that.update_materialProject.join(','),
					"smallInstrumentsContent": that.update_materialContent,
					"smallInstrumentsEffect": material_effect,
					"smallInstrumentsPicurl": that.update_uploadImgSrc.join(','),
					"trainingContent": that.update_softwareContent,
					"trainingEffect": software_effect,
					"trainingProject": that.update_softwareProject,
					"trainingType": that.update_type,
					"uenterpriseId": that.userInfo.uenterpriseId,
					"uenterpriseName": that.firmName,
					"umemo": that.update_remark,
					"updateTime": that.update_date,
					"userId": that.userInfo.uid,
					"userName": that.userInfo.u_r_name
				};
				Api.updateWithTraining(requestData).then((res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.update_display = false;
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				});
			},
			
			/****************** @delete **********************/
			// 点击删除
			handleDeleteClick(data) {
				const that = this;
				that.$confirm(
					'确定要删除该带训信息?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.list_loading = true;
						var requestData = {
							id: data.id
						};
						Api.deleteWithTraining(requestData).then((res) => {
							that.list_loading = false;
							if (res.data.success) {
								that.$message.success(res.data.message);
								that.getList();
							} else {
								that.$message.error(res.data.message);
							}
						}, (e) => {
							that.list_loading = false;
							that.$message.error(e.message);
						});
					});
			},
			
			
			/****************** @Function **********************/
			// 带训人匹配
			queryTrainer(queryString, cb) {
				const that = this;
				that.queryInterval && clearTimeout(that.queryInterval);
				that.queryInterval = setTimeout(() => {
					var results = [];
					var requestData = {
						name: queryString
					};
					Api.queryTrainerByName(requestData).then((res) => {
						if (res.data.success) {
							res.data.data.forEach(v => {
								results.push(v);
							});
							cb(results);
						} else {
							cb([]);
						}
					}, () => {
						cb([]);
					});
				}, 500);
			},
			// 根据日期获取带训信息
			getWithTrainingInfoByDate(type) {
				const that = this;
				type == 'add' && (that.add_loading = true);
				type == 'update' && (that.update_loading = true);
				var requestData = {};
				type == 'add' && (requestData = {
					id: that.uid,
					time: that.add_date
				});
				type == 'update' && (requestData = {
					id: that.uid,
					time: that.update_date
				});
				Api.getWithTrainingInfoByDate(requestData).then((res) => {
					type == 'add' && (that.add_loading = false);
					type == 'update' && (that.update_loading = false);
					if (res.data.success) {
						if (type == 'add') {
							that.add_softwareProject = res.data.data.projectName;
							that.add_softwareContent = '';
							res.data.data.trainingEffectInfoVoList
							&& res.data.data.trainingEffectInfoVoList.forEach(v => {
								that.add_softwareContent += `${ v.typeName }*${ v.count },`;
							});
							that.add_softwareContent 
							&& (that.add_softwareContent = that.add_softwareContent.slice(0, that.add_softwareContent.length - 1));
						} else if (type == 'update') {
							that.update_softwareProject = res.data.data.projectName;
							that.update_softwareContent = '';
							res.data.data.trainingEffectInfoVoList
							&& res.data.data.trainingEffectInfoVoList.forEach(v => {
								that.update_softwareContent += `${ v.typeName }*${ v.count },`;
							});
							that.update_softwareContent 
							&& (that.update_softwareContent = that.update_softwareContent.slice(0, that.update_softwareContent.length - 1));
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					type == 'add' && (that.add_loading = false);
					type == 'update' && (that.update_loading = false);
					that.$message.error(e.message);
				});
			},
			// 完成截图后要执行的方法
			imgCutterCutDown(file) {
				let base64 = file.dataURL;
				this.imgCutterType == 'add' && this.uploadImgForAdd(base64);
				this.imgCutterType == 'update' && this.uploadImgForUpdate(base64);
			},
			// 清空画布
			imgCutterClear() {
				this.imgCutterDisplay = false;
			},
			// 上传图片
			uploadImgForAdd(base64) {
				const that = this;
				that.add_loading = true;
				var timeDelegate = new Date().getTime(),
					picName = `${ timeDelegate }.png`,
					requestData = {
						base: base64,
						picName: picName,
						type: 'trainingPicture'
					};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.add_uploadImgSrc = [...that.add_uploadImgSrc, res.data.data.imgUrl.split('?')[0]];
						that.add_loading = false;
					} else {
						that.add_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			uploadImgForUpdate(base64) {
				const that = this;
				that.update_loading = true;
				var timeDelegate = new Date().getTime(),
					picName = `${ timeDelegate }.png`,
					requestData = {
						base: base64,
						picName: picName,
						type: 'trainingPicture'
					};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.update_uploadImgSrc = [...that.update_uploadImgSrc, res.data.data.imgUrl.split('?')[0]];
						that.update_loading = false;
					} else {
						that.update_loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				});
			},
			// 关闭预览图片
			closeViewer() {
				this.viewerDisplay = false;
			}
		},
		watch: {
			display (newVal) {
				this.list_display = newVal;
			},
			list_display (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.queryInterval && clearTimeout(this.queryInterval);
					this.imgCutterDisplay = false;
					this.imgCutterType = '';
					this.viewerDisplay = false;
					this.viewerImgList = [];
					this.userInfo = {};
					this.materials = [];
					this.software_training_situation = [];
					this.material_training_situation = [];
					this.view_info = {};
					this.view_materialProject = [];
					this.view_uploadImgSrc = [];
					
					this.list_loading = false;
					this.list_data = [];
					this.list_total = 0;
					this.list_page = 1;
					this.getUserInfo();
				}
			},
			add_display(newVal) {
				if (!newVal) {
					this.add_loading = false;
					this.add_date = '';
					this.add_trainerId = '';
					this.add_trainerName = '';
					this.add_trainerSubId = '';
					this.add_trainerSubName = '';
					this.add_trainerModel = '';
					this.add_trainerSubModel = '';
					this.add_softwareProject = '';
					this.add_softwareContent = '';
					this.add_softwareRecord_chips = [];
					this.add_softwareRecord = '';
					this.add_materialProject = [];
					this.add_materialContent = '';
					this.add_materialRecord_chips = [];
					this.add_materialRecord = '';
					this.add_remark = '';
					this.add_dateTip = false;
					this.add_trainerTip = false;
					this.add_uploadImgSrc = [];
				}
			},
			view_display(newVal) {
				if (!newVal) {
					this.view_loading = false;
				}
			},
			update_display(newVal) {
				if (!newVal) {
					this.update_loading = false;
					this.update_date = '';
					this.update_trainerId = '';
					this.update_trainerName = '';
					this.update_trainerSubId = '';
					this.update_trainerSubName = '';
					this.update_trainerModel = '';
					this.update_trainerSubModel = '';
					this.update_softwareProject = '';
					this.update_softwareContent = '';
					this.update_softwareRecord_chips = [];
					this.update_softwareRecord = '';
					this.update_oldMaterialProject = [];
					this.update_materialProject = [];
					this.update_materialContent = '';
					this.update_materialRecord_chips = [];
					this.update_materialRecord = '';
					this.update_remark = '';
					this.update_dateTip = false;
					this.update_trainerTip = false;
					this.update_trainerSubTip = false;
					this.update_uploadImgSrc = [];
				}
			},
			add_trainerModel(newValue) {
				if (newValue != this.add_trainerName) {
					this.add_trainerId = '';
					this.add_trainerName = '';
				}
			},
			add_trainerSubModel(newValue) {
				if (newValue != this.add_trainerSubName) {
					this.add_trainerSubId = '';
					this.add_trainerSubName = '';
				}
			},
			update_trainerModel(newValue) {
				if (newValue != this.update_trainerName) {
					this.update_trainerId = '';
					this.update_trainerName = '';
				}
			},
			update_trainerSubModel(newValue) {
				if (newValue != this.update_trainerSubName) {
					this.update_trainerSubId = '';
					this.update_trainerSubName = '';
				}
			},
			add_materialProject(newVal, oldVal) {
				if (newVal.length > oldVal.length) {
					let id = BaseMethods.getDiffFromDoubleArr(newVal, oldVal)[0];
					let content = '';
					this.materials.forEach(v => {
						id == v.id && (content = v.example);
					});
					this.add_materialContent += content;					
				}
			}
		},
		components: {
			ElImageViewer
		}
	}
</script>

<style>
</style>
